import { Link } from "./Link";

export { Link } from "./Link";
export { ScrollToLink } from "./ScrollToLink";
export { LinkButton } from "./LinkButton";
export { ExternalLink, ExternalLinkButton, ExternalTertiaryLinkButton, ExternalLinkTitle } from "./ExternalLink";

export default Link;
